export default "__VITE_ASSET__DSQ2k$bd__"